import { type ComponentPropsWithRef, memo } from 'react';

export const IconProfile = memo<ComponentPropsWithRef<'svg'>>((props) => (
	<svg
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M12 2.75C9.65279 2.75 7.75 4.65279 7.75 7C7.75 9.34721 9.65279 11.25 12 11.25C14.3472 11.25 16.25 9.34721 16.25 7C16.25 4.65279 14.3472 2.75 12 2.75ZM6.25 7C6.25 3.82436 8.82436 1.25 12 1.25C15.1756 1.25 17.75 3.82436 17.75 7C17.75 10.1756 15.1756 12.75 12 12.75C8.82436 12.75 6.25 10.1756 6.25 7Z"
			fill="#111111"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M2.66003 22C2.66003 17.5791 6.99716 14.25 12 14.25C17.0029 14.25 21.34 17.5791 21.34 22C21.34 22.4142 21.0042 22.75 20.59 22.75C20.1758 22.75 19.84 22.4142 19.84 22C19.84 18.6809 16.4772 15.75 12 15.75C7.52291 15.75 4.16003 18.6809 4.16003 22C4.16003 22.4142 3.82425 22.75 3.41003 22.75C2.99582 22.75 2.66003 22.4142 2.66003 22Z"
			fill="#111111"
		/>
	</svg>
));

export const IconProfileActive = (props: ComponentPropsWithRef<'svg'>) => (
	<svg
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M17 7C17 9.76142 14.7614 12 12 12C9.23858 12 7 9.76142 7 7C7 4.23858 9.23858 2 12 2C14.7614 2 17 4.23858 17 7ZM2.91003 22C2.91003 17.86 6.99003 14.5 12 14.5C17.01 14.5 21.09 17.86 21.09 22C21.09 22.28 20.87 22.5 20.59 22.5H3.41003C3.13003 22.5 2.91003 22.28 2.91003 22Z"
			fill="#111111"
		/>
	</svg>
);
